// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"799":"cc1d0a74","811":"b48639f0","992":"6236492b"}[chunkId] + ".chunk.js";
};